<template>
  <div class="terms-container">
    <div class="terms-content">
      <h1>{{ $t('terms.title') }}</h1>
      <div class="terms-section">
        <h2>{{ $t('terms.sections.acceptance.title') }}</h2>
        <p>{{ $t('terms.sections.acceptance.content') }}</p>
      </div>
      <div class="terms-section">
        <h2>{{ $t('terms.sections.services.title') }}</h2>
        <p>{{ $t('terms.sections.services.content') }}</p>
      </div>
      <div class="terms-section">
        <h2>{{ $t('terms.sections.userObligations.title') }}</h2>
        <p>{{ $t('terms.sections.userObligations.content') }}</p>
      </div>
      <div class="terms-section">
        <h2>{{ $t('terms.sections.privacy.title') }}</h2>
        <p>{{ $t('terms.sections.privacy.content') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerTerms'
}
</script>

<style scoped>
.terms-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.terms-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.terms-section {
  margin-bottom: 2rem;
}

h1 {
  color: #333;
  margin-bottom: 2rem;
  text-align: center;
}

h2 {
  color: #444;
  margin-bottom: 1rem;
}

p {
  color: #666;
  line-height: 1.6;
}
</style> 